import { EVENTS, CALENDAR_LAST_YEAR_PAGINATION_ALLOWED, JANUARY_INDEX, DECEMBER_INDEX, NOVEMBER_INDEX } from 'common/domain/constants';

class CalendarComponentController {
  constructor($scope, $timeout) {
    'ngInject';
    this.scope = $scope;
    this.timeout = $timeout;
  }

  $onInit() {
    this.id = this.options.id;
    this.month = this.options.defaultViewDate.month;
    this.monthCounter = this.month;
    this.date = new Date(this.options.defaultViewDate.year, this.month, this.options.defaultViewDate.day);
  }

  $postLink() {
    $(document).ready(() => {
      this.options.beforeShowDay = (date) => {
        return this.beforeShowDay({ $event: { date } });
      };

      this._initDatepickerJquery();
      this.datepicker.datepicker(this.options);
      this._initComponentParts();
      this.extraSettings();

      if(this.isMobileApp) {
        this._initMobileComponentParts();
      }
    });

    this.scope.$on(EVENTS.ADD_PERIOD, () => {
      this.restart();
    });

    this.scope.$on(EVENTS.FILTER_PERIOD, () => {
      this.restart();
    });

    this.scope.$on(EVENTS.CALENDAR_INLINE_CHANGE_DATE, (event, args) => {
      let isMatch = this.checkCoincidence(args);
      if (!args.newDate || !isMatch) return;
      this.options.defaultViewDate = {
        year: args.newDate.getFullYear(),
        month: args.newDate.getMonth(),
        day: this.options.defaultViewDate.day,
      };
      this.date = new Date(args.newDate.getFullYear(), args.newDate.getMonth(), 1);
      this.restart();
    });
  }

  checkCoincidence(args) {
    let coincidence = true;
    if (args.id) {
      coincidence = args.id == this.id;
    }

    return coincidence;
  }

  restart() {
    $(document).ready(() => {
      this.datepicker.datepicker('destroy');
      this.options.beforeShowDay = (date) => {
        return this.beforeShowDay({ $event: { date } });
      };

      this.datepicker.datepicker(this.options);
      this._initDatepickerJquery();
      this._initComponentParts();
      this.extraSettings();
      this.timeout(() => this.scope.$apply(), 100);
    });
  }

  _initDatepickerJquery() {
    if (this.id !== undefined) {
      this.datepicker = $(`[id="datepicker${this.month}${this.id}"]`);
    }else {
      this.datepicker = $(`[id="datepicker${this.month}"]`);
    }
  }

  _initComponentParts() {
    if (this.id !== undefined) {
      this.datepickerPreviousMonth = $(`[id="datepicker${this.month}${this.id}"] .datepicker-days thead .prev`);
      this.datepickerDay = $(`[id="datepicker${this.month}${this.id}"] td`);
      this.title = $(`[id="datepicker${this.month}${this.id}"] .datepicker-switch`);
    } else {
      this.datepickerPreviousMonth = $(`[id="datepicker${this.month}"] .datepicker-days thead .prev`);
      this.datepickerDay = $(`[id="datepicker${this.month}"] td`);
      this.title = $(`[id="datepicker${this.month}"] .datepicker-switch`);
    }
  }

  _initMobileComponentParts() {
    if (this.id !== undefined) {
      this.datepickerPreviousMonth = $(`[id="datepicker${this.month}${this.id}"] .datepicker-days thead .prev`);
      this.datepickerNextMonth = $(`[id="datepicker${this.month}${this.id}"] .datepicker-days thead .next`);
    } else {
      this.datepickerPreviousMonth = $(`[id="datepicker${this.month}"] .datepicker-days thead .prev`);
      this.datepickerNextMonth = $(`[id="datepicker${this.month}"] .datepicker-days thead .next`);
    }
    this._addIconClassCalendarMonth();
    this._bindDatepickerMobileEvents();
  }

  _addIconClassCalendarMonth() {
    this.datepickerPreviousMonth.addClass('icon-arrow-select-up');
    this.datepickerNextMonth.addClass('icon-arrow-select-up');
  }

  extraSettings() {
    this.bindDatepickerEvents();
    if (this.options.displayYear === false) this.removeYearFromTitle();
  }

  removeYearFromTitle() {
    if (this.title.html() != undefined)
      this.title.html(this.title.html().replace(/[0-9]/g, ''));
  }

  bindDatepickerEvents() {
    this._initClick();
    this._initHover();
  }

  _bindDatepickerMobileEvents() {
    this._initClickPreviousMonth();
    this._initClickNextMonth();
  }

  _initClick() {
    this.datepickerDay.click((event) => {
      event.stopPropagation();
      const dayClicked = event.currentTarget;
      const dateDayClicked = new Date(this.date.getFullYear(), this.date.getMonth(), event.target.innerText);
      this.onClick({ $event: { dayClicked, dateDayClicked } });
    });
  }

  _initHover() {
    this.datepickerDay.hover((event) => {
      event.stopPropagation();
      const dayHovered = event.currentTarget;
      const dateDayHovered = new Date(this.date.getFullYear(), this.date.getMonth(), event.target.innerText);
      this.onHoverIn({ $event: { dayHovered, dateDayHovered } });
    }, (event) => {
      const dayHovered = event.currentTarget;
      const dateDayHovered = new Date(this.date.getFullYear(), this.date.getMonth(), event.target.innerText);
      this.onHoverOut({ $event: { dayHovered, dateDayHovered } });
    });
  }

  _initClickPreviousMonth() {
    this.datepickerPreviousMonth.click((event) => {
      const isFirstMonth = this.monthCounter === JANUARY_INDEX;
      const isLastMonthPaginable = this.dateToday.getFullYear() === CALENDAR_LAST_YEAR_PAGINATION_ALLOWED && isFirstMonth;
      
      if(isLastMonthPaginable) {
        event.stopPropagation();
        return;
      }

      if(isFirstMonth) {
        this.monthCounter = DECEMBER_INDEX;
        this.onClickPrevious();
      }else{
        this.monthCounter -= 1;

      }
    });
  }

  _initClickNextMonth() {
    this.datepickerNextMonth.click(() => {
      const today = new Date();
      const isLastMonth = this.monthCounter === DECEMBER_INDEX;
      const isLastMonthOfNewYear = this.dateToday.getFullYear() === (today.getFullYear() +1) && isLastMonth;
      const isBeforeTwentyNovember = today.getMonth() < NOVEMBER_INDEX && today.getDay() < 20 && this.dateToday.getFullYear() === today.getFullYear();
      const notShouldPaginateToNewYear = isLastMonth && isBeforeTwentyNovember;

      if(isLastMonthOfNewYear || notShouldPaginateToNewYear) {
        event.stopPropagation();
        return;
      }

      if(isLastMonth) {
        this.monthCounter = JANUARY_INDEX; 
        this.onClickNext();
      }else{
        this.monthCounter += 1;

      }
    });
  }
}
export default CalendarComponentController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarComponent/calendarComponent.controller.js